import * as API from "./mediagroup_api"
export default API;
